import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Col from 'reactstrap/lib/Col';
import { IHistory } from '../../interfaces';
import { ModuleModel } from '../../model/ModuleModel';
import { UserModel } from '../../model/UserModel';
import { deleteModule } from '../../services/moduleService';
import { isMobileDevice, userUniqueID } from '../../utils/generalUtils';
import { Icon } from '../reusableComponents/Icon';
import { DeleteModuleDialog } from './DeleteModuleDialog';
import { CategoryFilter } from './CategoryFilter';
import './modules.scss';
export interface IListItemProps {
    instance?: ModuleModel;
    index?: number;
    listItemProp?: string;
    onClick?: Function;
    className?: string;
    history?: IHistory;
    selectedIds?: string[];
    userInstance?: UserModel;
    Category?: [];
    SubCategory?: [];
    onRowSelect: (id: string, index: number) => void;
}

interface IListItemState {
    open: boolean;
    hovered: boolean;
    selected: boolean;
    hideOptions: boolean;
}

export class ListItemImpl extends React.Component<IListItemProps, IListItemState> {
    isMobile = isMobileDevice();
    constructor(props: IListItemProps) {
        super(props);
        this.state = { open: false, hovered: false, selected: false, hideOptions: false };
    }

    public componentWillReceiveProps(nextProps: IListItemProps) {
        this.setState({
            hideOptions: nextProps.selectedIds.length > 0
        });
    }

    public handleClose = () => {
        this.setState({
            open: false
        });
    }

    public handleOnDeleteModule = async () => {
        const { ModuleID, Name } = this.props.instance.props;
        try {
            await deleteModule([ModuleID], Name);
            this.setState({ open: false });
        } catch (error) {
            this.setState({ open: false });
            throw error;
        }
    }

    public handleRowSelect = () => {
        const { instance, index } = this.props;
        this.setState({
            selected: !this.state.selected
        });
        this.props.onRowSelect(instance.props.id, index);
    }

    public render() {
        const { instance, history, index, userInstance } = this.props;
        const isAdmin = UserModel.isAdmin(userInstance);
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);

        return <div
            className={`list-item ${this.state.selected ? 'list-item-selected' : ''}`}
            onMouseOver={() => this.setState({ hovered: true })}
            onMouseLeave={() => this.setState({ hovered: false })}
        >
            <DeleteModuleDialog
                onClose={() => this.setState({ open: false })}
                open={this.state.open}
                moduleIds={this.props.instance ? [this.props.instance.props.ModuleID] : []}
                textToDisplay={this.props.instance ? this.props.instance.props.Name : 'this'} 
                history={this.props.history}/>
            <Col
                onClick={
                    instance.props.Completed && !isAdmin ? null :
                        () => history.push(`/training/${instance.props.id}`)
                }
                className="serial-no center"
                sm={1}
            >
                {index}
            </Col>
            <Col
                onClick={
                    instance.props.Completed && !isAdmin ? null :
                        () => history.push(`/training/${instance.props.id}`)
                }
                className="module-name"
                sm={isAdmin ? 2 : 2}
            >
                {instance.props.Name}
            </Col>
            <Col
                onClick={
                    instance.props.Completed && !isAdmin ? null :
                        () => history.push(`/training/${instance.props.id}`)
                }
                className="module-name category"
                sm={isAdmin ? 2 : 2}
            >
                {instance.props.Category}
            </Col>
            <Col
                onClick={
                    instance.props.Completed && !isAdmin ? null :
                        () => history.push(`/training/${instance.props.id}`)
                }
                className="module-name duration"
                sm={isAdmin ? 2 : 2}
            >
                {instance.props.TrainingDuration + ' Days'}
            </Col>
            {
                (isAdmin || isSuperAdmin) &&  <Col
                    onClick={
                        instance.props.Completed && !isAdmin ? null :
                            () => history.push(`/training/${instance.props.id}`)
                    }
                    className="module-name created-date"
                    sm={isAdmin ? 2 : 2}
                >
                    {instance.props.DateCreated}
                </Col>
            }
            {!isAdmin && !isSuperAdmin ?
                [<Col
                    key={1}
                    onClick={
                        instance.props.Completed ? null :
                            () => history.push(`/training/${instance.props.id}`)
                    }
                    className="module-name" sm={2} >
                    {instance.props && instance.props.DueDate}
                </Col>,
                <Col
                    key={3}
                    onClick={
                        instance.props.Completed ? null :
                            () => history.push(`/training/${instance.props.id}`)
                    }
                    className="Status" sm={1} >
                    {/* {instance.props.Completed ? <Icon icon="check-circle" /> : <Icon icon="exclamation-triangle" />} */}
                    {/* {instance.props.CompletedStatus == '1' ? <Icon icon="check-circle" /> : instance.props.CompletedStatus == '0' ? <Icon icon="clock" /> : <Icon icon="exclamation-triangle" />} */}
                    {instance.props.CompletedStatus == '4' ? <Icon icon="check-circle" /> : instance.props.CompletedStatus == '2' || instance.props.CompletedStatus == '3' ? <Icon icon="clock" /> : <Icon icon="exclamation-triangle" />}

                    &nbsp;
                    {/* {instance.props.Completed ? 'Completed' : 'Pending.'} */}
                    {instance.props.CompletedStatus == '4' ? 'Completed' : instance.props.CompletedStatus == '2' || instance.props.CompletedStatus == '3' ? 'Pending' : 'Overdue'}

                </Col>,
                    <Col
                        key={2}
                        onClick={
                            instance.props.Completed ? null :
                                () => history.push(`/training/${instance.props.id}`)
                        }
                        className="DateCompleted" sm={2} >
                        {instance.props && instance.props.DateCompleted}
                    </Col>
                ]
                : ''}
            {/*{
                this.state.hovered || this.state.selected ?
                    <Col
                        title="Click to select multiple."
                        onClick={this.handleRowSelect}
                        className="edit multiple-select" sm={1}
                    >
                        <Icon icon="check-square" />
                    </Col>
                    : ''
            }*/}

            {isAdmin || isSuperAdmin && !this.state.hideOptions ?
                <div className="mobile-container col-sm-3 " >
                    <Col
                        key="pencil"
                        onClick={() => history.push(`/training/edit/${instance.props.id}`)}
                        className="edit"
                        sm={this.isMobile?6:3} >
                        <Icon icon="pencil-alt" />
                    </Col>
                    <Col
                        key="trash"
                        onClick={() => this.setState({ open: true })}
                        className="trash"
                        sm={6} >
                        <Icon icon="trash" />
                    </Col>
                </div> :
                ''}
        </div>;
    }
}

export function mapStateToProps(state) {
    return {
        selectedIds: state.forms.selectedListItems.listItems,
        userInstance: UserModel.get(userUniqueID(state))
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/ListItems.tsx